<template>
  <div>
    <CustomModal :open="modal.open" :type="modal.type" @close-modal="modal.open = false">
      <template slot="modal_content">
        <p>{{modal.message}}</p>
      </template>
    </CustomModal>
    <form @submit.prevent="vSignUp" ref="signup_form" autocomplete="new-password">
      <div class="grid-row">
        <div class="c-4">
          <div class="form-field">
            <input
              type="radio"
              class="radio"
              name="test"
              :id="'customer_exist'"
              v-model="form_info.form_type"
              v-bind:value="'E'"
            />
            <label :for="'customer_exist'">{{$_('already_customer')}}</label>
          </div>
        </div>
        <div class="c-4">
          <div class="form-field">
            <input
              type="radio"
              class="radio"
              name="test"
              :id="'customer_new'"
              v-model="form_info.form_type"
              v-bind:value="'N'"
            />
            <label :for="'customer_new'">{{$_('new_customer')}}</label>
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('company')}}</label>
            <Select
              :placeholder="'Société'"
              :itemoption="['PCSOC', 'PLIBSOC']"
              :data="form_info.company"
              :search="false"
              :ref="'pcsoc'"
              :resetselect="reset_field"
              :required="true"
              @select-change="vSetStore('tcsoc', $event.item)"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6" v-if="getFormType === 'E'">
          <div class="form-field">
            <label>{{$_('customer_number')}}</label>
            <Input
              :type="'number'"
              :required="true"
              :reset="reset_field"
              :ref="'tnocl'"
              @typing="vSetStore('tnocl', $event.toUpperCase())"
            />
            <span class="input-error">{{error_customer_number_message}}</span>
          </div>
        </div>
      </div>
      <div class="grid-row" v-if="getFormType === 'N'">
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('language')}}</label>
            <Select
              :placeholder="$_('language')"
              :itemoption="['TCLANG', 'TLIB_LANG']"
              :data="form_info.lang"
              :search="true"
              :required="true"
              :ref="'tclang'"
              :resetselect="reset_field"
              @select-change="vSetStore('tclang', $event.item)"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('social_reason')}}</label>
            <Input
              :type="'text'"
              :required="true"
              :ref="'tnom'"
              :reset="reset_field"
              :maxlength="25"
              @typing="vSetStore('tnom', $event.toUpperCase())"
            />
          </div>
        </div>
      </div>

      <div class="grid-row" v-if="getFormType === 'N'">
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('division')}}</label>
            <Select
              :placeholder="$_('division')"
              :itemoption="['TCDIV', 'TLIB_DIV']"
              :data="form_info.division"
              :search="true"
              :resetselect="reset_field"
              @select-change="vSetStore('tcdiv', $event.item)"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('sub_division')}}</label>
            <Select
              :placeholder="'Sous division'"
              :itemoption="['TCSDIV', 'TLIB_SDIV']"
              :data="form_info.sub_division"
              :search="true"
              :resetselect="reset_field"
              @select-change="vSetStore('tcsdiv', $event.item)"
            />
          </div>
        </div>
      </div>
      <!-- LIVRASON -->
      <div class="grid-row" v-if="getFormType === 'N'">
        <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <div class="form-field">
            <label>{{$_('delivery_address')}} 1</label>
            <Input
              :type="'text'"
              :required="true"
              :ref="'tadr1l'"
              :maxlength="25"
              :reset="reset_field"
              @typing="vSetStore('tadr1l', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <div class="form-field">
            <label>{{$_('delivery_address')}} 2</label>
            <Input
              :type="'text'"
              :maxlength="25"
              :reset="reset_field"
              @typing="vSetStore('tadr2l', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <div class="form-field">
            <label>{{$_('delivery_address')}} 3</label>
            <Input
              :type="'text'"
              :maxlength="25"
              :reset="reset_field"
              @typing="vSetStore('tadr3l', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('customer_delivery_postal_code')}}</label>
            <Input
              :type="'text'"
              :required="true"
              :ref="'tcpostl'"
              :maxlength="10"
              :reset="reset_field"
              @typing="vSetStore('tcpostl', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('city')}}</label>
            <Input
              :type="'text'"
              :required="true"
              :ref="'tvillel'"
              :maxlength="30"
              :reset="reset_field"
              @typing="vSetStore('tvillel', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('country')}}</label>
            <Select
              :placeholder="$_('country')"
              :itemoption="['TCPAYS', 'TLIB_PAYS']"
              :data="form_info.country"
              :search="true"
              :required="true"
              :ref="'tcpayl'"
              :resetselect="reset_field"
              @select-change="vSetStore('tcpaysl', $event.item)"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('district_region')}}</label>
            <Select
              :placeholder="$_('district_region')"
              :itemoption="['TCPROV', 'TLIB_PROV']"
              :data="form_info.district_l"
              :search="true"
              :resetselect="reset_field"
              @select-change="vSetStore('tcprovl', $event.item)"
            />
          </div>
        </div>
        <!-- FACTURATION -->
        <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <div class="form-field">
            <label>{{$_('billing_address')}} 1</label>
            <Input
              :type="'text'"
              :maxlength="25"
              :reset="reset_field"
              @typing="vSetStore('tadr1f', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <div class="form-field">
            <label>{{$_('billing_address')}} 2</label>
            <Input
              :type="'text'"
              :maxlength="25"
              :reset="reset_field"
              @typing="vSetStore('tadr2f', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <div class="form-field">
            <label>{{$_('billing_address')}} 3</label>
            <Input
              :type="'text'"
              :maxlength="25"
              :reset="reset_field"
              @typing="vSetStore('tadr3f', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('customer_billing_postal_code')}}</label>
            <Input
              :type="'text'"
              :maxlength="10"
              :reset="reset_field"
              @typing="vSetStore('tcpostf', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('city')}}</label>
            <Input
              :type="'text'"
              :maxlength="30"
              :reset="reset_field"
              @typing="vSetStore('tvillef', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('country')}}</label>
            <Select
              :placeholder="'Pays'"
              :itemoption="['TCPAYS', 'TLIB_PAYS']"
              :data="form_info.country"
              :search="true"
              :required="tcpaysf_required"
              :ref="'tcpaysf'"
              :resetselect="reset_field"
              @select-change="vSetStore('tcpaysf', $event.item)"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('district_region')}}</label>
            <Select
              :placeholder="'Province'"
              :itemoption="['TCPROV', 'TLIB_PROV']"
              :data="form_info.district_f"
              :search="true"
              :resetselect="reset_field"
              @select-change="vSetStore('tcprovf', $event.item)"
            />
          </div>
        </div>

        <!-- Info général -->

        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('phone_number')}}</label>
            <Input
              :type="'tel'"
              :required="true"
              :ref="'ttel'"
              :maxlength="13"
              :reset="reset_field"
              @typing="vSetStore('ttel', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('currency')}}</label>
            <Select
              :placeholder="$_('currency')"
              :itemoption="['TCDEV', 'TLIB_DEV']"
              :data="form_info.currency"
              :ref="'tcdev'"
              :required="true"
              :search="true"
              :resetselect="reset_field"
              @select-change="vSetStore('tcdev', $event.item)"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('siret')}}</label>
            <Input
              :type="'text'"
              :maxlength="17"
              :reset="reset_field"
              @typing="vSetStore('tsiret', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('tva_number')}}</label>
            <Input
              :type="'text'"
              :maxlength="17"
              :reset="reset_field"
              @typing="vSetStore('ttvacee', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('website')}}</label>
            <Input
              :type="'text'"
              :required="true"
              :ref="'tweb'"
              :reset="reset_field"
              :maxlength="60"
              @typing="vSetStore('tweb', $event.toUpperCase())"
            />
          </div>
        </div>
      </div>
      <!-- Info contact -->
      <div class="grid-row">
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('primary_contact_name')}}</label>
            <Input
              :type="'text'"
              :required="true"
              :ref="'tnomc'"
              :reset="reset_field"
              :maxlength="25"
              @typing="vSetStore('tnomc', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('primary_contact_firstname')}}</label>
            <Input
              :type="'text'"
              :required="true"
              :ref="'tpnomc'"
              :maxlength="25"
              :reset="reset_field"
              @typing="vSetStore('tpnomc', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-6 c-xs-12 c-sm-12 c-md-6 c-lg-6">
          <div class="form-field">
            <label>{{$_('primary_contact_email')}}</label>
            <Input
              :type="'email'"
              :required="true"
              :ref="'tmailc'"
              :maxlength="40"
              :reset="reset_field"
              @typing="vSetStore('tmailc', $event.toUpperCase())"
            />
          </div>
        </div>
      </div>
      <div class="grid-row">
        <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <div class="form-field">
            <label>{{$_('password')}}</label>
            <Input
              :type="'password'"
              :required="true"
              :ref="'pmdp'"
              :maxlength="100"
              :reset="reset_field"
              @typing="vSetStore('pmdp', $event)"
            />
          </div>
          <div class="form-field">
            <label>{{$_('password_confirm')}}</label>
            <Input
              :type="'password'"
              :required="true"
              :ref="'pmdp_confirm'"
              :maxlength="100"
              :reset="reset_field"
              @typing="vSetStore('pmdp_confirm', $event)"
            />
          </div>
        </div>
      </div>
      <div class="grid-row">
        <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
          <input :disabled="current_send" type="submit" :value="$_('register')" class="btn" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Select from "@/common/components/widget/Select";
import CustomModal from "@/common/components/widget/Modal/CustomModal";
import Input from "@/common/components/widget/Input/Input";

import customerService from "@/modules/client/services/customerService";
import authService from "@/modules/authentification/services/authService";

export default {
  name: "SignUp",
  data() {
    return {
      modal: {
        open: false,
        type: "default",
        message: ""
      },
      form_info: {
        company: Array(),
        lang: Array(),
        country: Array(),
        district_l: Array(),
        district_f: Array(),
        division: Array(),
        sub_division: Array(),
        currency: Array(),
        form_type: "N",
        pcsoc: "",
        password: "",
        password_confirm: ""
      },
      error_count: 0,
      reset_field: false,
      tcpaysf_required: false,
      current_send: false,
      timer: null,
      tcsoc: null,
      error_customer_number_message: '',
      error_customer_number: 0,
    };
  },
  components: {
    Select,
    CustomModal,
    Input
  },
  created() {
    this.getSignUpCompany();
  },
  methods: {
    vSignUp() {

      if(this.current_send === true) {
        return;
      }
      
      if (this.current_send === false) {

        this.current_send = true;
        this.error_count = 0;

        Object.values(this.$refs).map(ref => {
          if (
            ref !== undefined &&
            ref.required &&
            ref.currentValue !== undefined
          ) {
            if (ref.currentValue === "") {
              ref.activate_required = true;
              ++this.error_count;
            } else {
              ref.activate_required = false;
              this.error_count > 1 ? --this.error_count : 0;
            }

            if (ref.type === "password" && ref.currentValue.length < 6) {
              ref.$data.customText = this.$_("password_length_error");
              ++this.error_count;
            } else {
              ref.$data.customText = "";
              this.error_count > 1 ? --this.error_count : 0;
            }
          }

          if (ref !== undefined && ref.required && ref.selected !== undefined) {
            if (Object.keys(ref.selected).length === 0) {
              ref.activate_required = true;
              ++this.error_count;
            } else {
              ref.activate_required = false;
              this.error_count > 1 ? --this.error_count : 0;
            }
          }
        });

        let nNbError;

        if (this.getFormType === 'E') {
          nNbError = this.error_count + this.error_customer_number;
        } else {
          nNbError = this.error_count;
        }

        if (nNbError === 0) {
          if (
            this.$store.getters["authentification/get_pmdp"] ===
            this.$store.getters["authentification/get_pmdp_confirm"]
          ) {
            authService
              .vSignUp({
                TCSOC: this.$store.getters["authentification/get_tcsoc"],
                TNOCL: this.$store.getters["authentification/get_tnocl"],
                TCLANG: this.$store.getters["authentification/get_tclang"],
                TNOM: this.$store.getters["authentification/get_tnom"],
                TADR1L: this.$store.getters["authentification/get_tadr1l"],
                TADR2L: this.$store.getters["authentification/get_tadr2l"],
                TADR3L: this.$store.getters["authentification/get_tadr3l"],
                TCPOSTL: this.$store.getters["authentification/get_tcpostl"],
                TVILLEL: this.$store.getters["authentification/get_tvillel"],
                TCPAYSL: this.$store.getters["authentification/get_tcpaysl"],
                TCPROVL: this.$store.getters["authentification/get_tcprovl"],
                TADR1F: this.$store.getters["authentification/get_tadr1f"],
                TADR2F: this.$store.getters["authentification/get_tadr2f"],
                TADR3F: this.$store.getters["authentification/get_tadr3f"],
                TCPOSTF: this.$store.getters["authentification/get_tcpostf"],
                TVILLEF: this.$store.getters["authentification/get_tvillef"],
                TCPAYSF: this.$store.getters["authentification/get_tcpaysf"],
                TCPROVF: this.$store.getters["authentification/get_tcprovf"],
                TTEL: this.$store.getters["authentification/get_ttel"],
                TCDIV: this.$store.getters["authentification/get_tcdiv"],
                TCSDIV: this.$store.getters["authentification/get_tcsdiv"],
                TCCOM: this.$store.getters["authentification/get_tccom"],
                TCDEV: this.$store.getters["authentification/get_tcdev"],
                TSIRET: this.$store.getters["authentification/get_tsiret"],
                TTVACEE: this.$store.getters["authentification/get_ttvacee"],
                TWEB: this.$store.getters["authentification/get_tweb"],
                TNOMC: this.$store.getters["authentification/get_tnomc"],
                TPNOMC: this.$store.getters["authentification/get_tpnomc"],
                TMAILC: this.$store.getters["authentification/get_tmailc"],
                TMDP: this.$store.getters["authentification/get_pmdp"]
              })
              .then(res => {
                if (res.data !== undefined && res.data.PIDUSER !== 0) {
                  this.modal.type = "error";
                  this.modal.open = true;
                  this.modal.message = this.$_('user_already_exist')
                  this.current_send = false;
                  this.error_count = 0;

                } else {
                  this.modal.type = "success";
                  this.modal.open = true;
                  this.modal.message = this.$_('account_created')

                  this.reset_field = true;

                  this.error_count = 0;
                  this.current_send = false;

                  setTimeout(() => {
                    this.reset_field = false;
                  }, 2000);

                }
              });
          } else {
            this.modal.type = "error";
            this.modal.open = true;
            this.modal.message = this.$_('password_not_match');

            this.current_send = false;
          }

        } else {
          this.current_send = false;
        }
      } 
    },
    vLoadCompanyData(pcsoc) {
      this.form_info.pcsoc = pcsoc;

      this.getLang();
      this.getCountry();
      this.getDivision();
      this.getCurrency();
    },
    vSetStore(key, value) {
      if (key === "tcpaysl") this.getDistrictL(value);
      if (key === "tcpaysf") this.getDistrictF(value);
      if (key === "tcdiv") this.getSubDivision(value);
      if (key === "tcsoc") {
        this.vLoadCompanyData(value);
        this.vCheckCustomer(this.form_info.pcsoc, this.tcsoc)
      }
      if (key === "tadr1f") {
        if (value.length > 0) {
          this.tcpaysf_required = true;
        } else {
          this.tcpaysf_required = false;
        }
      }
      if(key === "tnocl") {

        this.error_customer_number
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.tcsoc = value;
          this.vCheckCustomer(this.form_info.pcsoc, value)
        }, 1000);
      }

      this.$store.dispatch("authentification/SET", { key, value });
    },
    vCheckCustomer(pcsoc, tcsoc) {
      customerService.getCustomerExist(pcsoc, tcsoc).then(res => {
        if(res.data === null) {
          this.error_customer_number_message = this.$_('no_company_selected')
          this.error_customer_number = 1;
        } else if (res.data.POK === 0) {
          this.error_customer_number_message = this.$_('no_customer_exist')
          this.error_customer_number = 1;
        } else {
          this.error_customer_number_message = ''
          this.error_customer_number = 0;
        }
      });
    },
    getSignUpCompany() {
      customerService.getSignUpCompany().then(res => {
        this.form_info.company = res.data.DS_O.OUT;
      });
    },
    getLang() {
      customerService.getLang(this.form_info.pcsoc).then(res => {
        this.form_info.lang = res.data.DS_O.OUT;
      });
    },
    getCountry() {
      customerService.getCountry(this.form_info.pcsoc).then(res => {
        this.form_info.country = res.data.DS_O.OUT;
      });
    },
    getDistrictL(country_code) {
      customerService
        .getDistrict(country_code, this.form_info.pcsoc)
        .then(res => {
          this.form_info.district_l = res.data.DS_O.OUT;
        });
    },
    getDistrictF(country_code) {
      customerService
        .getDistrict(country_code, this.form_info.pcsoc)
        .then(res => {
          this.form_info.district_f = res.data.DS_O.OUT;
        });
    },
    getDivision() {
      customerService.getDivision(this.form_info.pcsoc).then(res => {
        this.form_info.division = res.data.DS_O.OUT;
      });
    },
    getSubDivision(pcdiv) {
      customerService.getSousDivision(pcdiv, this.form_info.pcsoc).then(res => {
        this.form_info.sub_division = res.data.DS_O.OUT;
      });
    },
    getCurrency() {
      customerService.getCurrency(this.form_info.pcsoc).then(res => {
        this.form_info.currency = res.data.DS_O.OUT;
      });
    }
  },
  computed: {
    getFormType() {
      return this.form_info.form_type;
    }
  },
  watch: {
    getFormType() {
      this.$refs.signup_form.reset();
      this.$store.dispatch("authentification/RESET");
    }
  }
};
</script>

<style scoped>
.inline-form {
  display: flex;
}
.form-field {
  margin-bottom: 0;
}
/deep/ .select-box {
  margin: 0;
}
/deep/ input {
  width: 100%;
}
</style>